(function() {
    // behaves like c# string.format - e.g. String.format("the {0} cat {1} jumped over the {2}", "brown", "jumped", "the lazy bones");
    String.format = String.format || function () {
        var args = Array.prototype.slice.call(arguments, 0);
        return kendo.format.apply(kendo, args);
    };
}());

define("fileplanstringex", function(){});

